export default __webpack_public_path__ + "static/33-dea74ff0bd91905651c7fc48fba7940c.png";